import {
  PRICES_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  PRICES_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD,
  PRICES_MASSIVE_UPLOAD_REQUEST_VERIFY,
  PRICES_MASSIVE_UPLOAD_SET_VERIFY,
  PRICES_MASSIVE_UPLOAD_CLEAR_VERIFY,
  PRICES_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  PRICES_MASSIVE_UPLOAD_SET_UPLOAD,
  PRICES_MASSIVE_UPLOAD_CLEAR_UPLOAD,
} from '../actions';

function pricesMassiveUploadReducer(state = {}, action) {
  const { type } = action;

  switch (type) {
    case PRICES_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: action.payload,
      };

    case PRICES_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: null,
      };

    case PRICES_MASSIVE_UPLOAD_REQUEST_VERIFY:
      return {
        ...state,
        isLoading: true,
        verify: null,
      };

    case PRICES_MASSIVE_UPLOAD_SET_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: action.payload,
      };

    case PRICES_MASSIVE_UPLOAD_CLEAR_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: null,
      };

    case PRICES_MASSIVE_UPLOAD_REQUEST_UPLOAD:
      return {
        ...state,
        isLoading: true,
        upload: null,
      };

    case PRICES_MASSIVE_UPLOAD_SET_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: action.payload,
      };

    case PRICES_MASSIVE_UPLOAD_CLEAR_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: null,
      };

    default:
      return state;
  }
}

export default pricesMassiveUploadReducer;
